import axios from 'axios';

export const ERROR_MSG_ABORTED = 'Request aborted';

export const CancelToken = axios.CancelToken;

export const isCancel = axios.isCancel;
